import { Language } from '@/i18n/constants'
import { parseLanguage } from '@/i18n/utils'

const LANGAUAGES_LOCALES_MAPPING: Record<Language, string> = {
  [Language.TH]: 'th-TH',
  [Language.EN]: 'en-US',
  [Language.MY]: 'my-MM',
  [Language.KM]: 'km-KH',
}

/**
 * Formats a number based on the specified language
 * @param value - The number to format
 * @param language - The language code (e.g., 'en', 'th')
 * @param options - Intl.NumberFormatOptions for additional formatting
 * @returns Formatted number string
 */
export const formatNumber = (
  value: number,
  language: string = Language.EN,
  options: Intl.NumberFormatOptions = {},
): string => {
  try {
    // Default options
    const defaultOptions: Intl.NumberFormatOptions = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    }

    const locale = LANGAUAGES_LOCALES_MAPPING[parseLanguage(language)]

    return new Intl.NumberFormat(locale, defaultOptions).format(value)
  } catch (error) {
    console.error('Error formatting number:', error)
    return value.toString()
  }
}

/**
 * Formats a price value based on the current language
 * @param value - The price value to format
 * @param i18n - The i18n object from useTranslation()
 * @returns Formatted price string
 */
export const formatPrice = (
  value: number,
  i18n: { language: string },
): string => {
  return formatNumber(value, i18n.language, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
